import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import InviteReqConfirmationPageContent from '../PageContent/InviteReqConfirmationPageContent';

const InviteRequestConfirmation = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="sm" backButton={false}>
            <PageTitle
                heading="Your request has been sent!"
            />
            <SectionDivider width="70%" />
            <InviteReqConfirmationPageContent />
        </HeaderAndBodyLayout>
    );
};

export default InviteRequestConfirmation;